// operation comes as { [key: string]: unknown } (serde_json::Value); narrow manually.
type RawOperation = { kind?: string; [key: string]: unknown };

const stringOrUndefined = (value: unknown): string | undefined => (typeof value === 'string' ? value : undefined);

const humanizeOperationKind = (kind: string): string => {
  const [first = '', ...rest] = kind.replaceAll('_', ' ');
  return `${first.toUpperCase()}${rest.join('')}`;
};

const translateOperation = (operation: unknown): string => {
  if (!operation || typeof operation !== 'object') return 'Change';
  const op = operation as RawOperation;

  if (op.kind === 'add_node') {
    if (op.nodeKind === 'rules') return 'Add rules';
    if (op.nodeKind === 'decision') return 'Add decision';
    return 'Add task';
  }

  if (op.kind === 'add_catalog_task') return 'Add task from template';

  if (op.kind === 'update_node') {
    const node = op.node as { name?: unknown } | undefined;
    const name = stringOrUndefined(node?.name);
    return name ? `Edit "${name}"` : 'Edit node';
  }

  if (op.kind === 'remove_node') return 'Remove node';

  if (op.kind === 'reorder_node') {
    const direction = stringOrUndefined(op.direction);
    return direction ? `Move ${direction}` : 'Move node';
  }

  if (op.kind === 'update_norms') return 'Edit norms';

  if (op.kind === 'update_skills') return 'Edit skills';

  if (op.kind === 'update_inputs') return 'Edit inputs';

  if (op.kind === 'update_tools') return 'Edit tools';

  if (op.kind === 'paste_node') {
    const node = op.node as { name?: unknown } | undefined;
    const name = stringOrUndefined(node?.name);
    return name ? `Paste "${name}"` : 'Paste node';
  }

  if (op.kind === 'replace_graph') {
    return op.restoredFromVersionId ? 'Restored graph from old version' : 'Replace graph';
  }

  if (op.kind) return humanizeOperationKind(op.kind);

  return 'Change';
};

export default translateOperation;
